module.exports = __webpack_public_path__ + "media/packs/images/flags/LC-2daca0ab3080e244cea89dbc8df085e0.svg";